/**
 * Builds an LDP URL to be fed into our `api-website-navigation` service
 * to know about redirections.
 *
 * @remarks
 * This will always return a `/${section}(/commercial)?/details/${listingId}/` URI even if we provide
 * a `/${section}(/commercial)?/details/contact/${listingId}/`.
 *
 * @param fullPath - String representing the current URL we are in
 * @param listingIdParam - String representing the Listing ID from the parameters
 * @returns - an LDP URL following the pattern `/${section}(/commercial)?/details/${listingId}/`
 */
const getPathForNavApi = (fullPath: string, listingId: number) => {
    const [section] = fullPath?.split('/details').filter((v) => v);
    return `/${section}/details/${listingId}/`.replace(/\/{2,}/g, '/');
};

export default getPathForNavApi;
